import { useRouter } from "next/router"
import Link from "next/link"
import React, { Children } from "react"

const ActiveLink = ({ children, activeClassName, forceNativeNavigation, ...props }) => {
  const { asPath } = useRouter()
  const child = Children.only(children)
  const childClassName = child.props.className || ""

  const className =
    asPath === props.href
      ? `${childClassName} ${activeClassName}`.trim()
      : childClassName

  if (forceNativeNavigation) {
    return React.cloneElement(child, {
      className: className || null,
      href: props.href,
      as: undefined,
    })
  }

  return (
    <Link {...props}>
      {React.cloneElement(child, {
        className: className || null,
      })}
    </Link>
  )
}

export default ActiveLink
